angular.module('Services')
    .factory('ComplianceService', function ($http, $rootScope, Error, Request) {
        return {
            getAll: function (callback, errorCallback, filter) {
                Request.get({
                    url: ApiURLs.compliance.compliance,
                    successCallback: callback,
                    errorCallback: errorCallback,
                    data: filter
                });
            },
            getDetails: function (callback, errorCallback, id) {
                Request.get({
                    url: ApiURLs.compliance.complianceDetails.replace(':id', id),
                    successCallback: callback,
                    errorCallback: errorCallback
                });
            },
            update: function (id, payload, callback, errorCallback) {
                Request.post({
                    url: ApiURLs.compliance.complianceDetails.replace(':id', id),
                    method: 'PUT',
                    successCallback: callback,
                    errorCallback: errorCallback
                }, payload);
            },
            create: function (payload, callback, errorCallback) {
                Request.post({
                    url: ApiURLs.compliance.compliance,
                    method: 'POST',
                    successCallback: callback,
                    errorCallback: errorCallback
                }, payload);
            },
            attachments: {
                getAll: function (id, callback, errorCallback, filter) {
                    Request.get({
                        url: ApiURLs.compliance.attachment,
                        successCallback: callback,
                        errorCallback: errorCallback,
                        data: filter
                    });
                },
                create: function (callback, errorCallback, payload) {
                    Request.post({
                        url: ApiURLs.compliance.attachment,
                        method: 'POST',
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, payload);
                },
                update: function (callback, errorCallback, id, payload) {
                    Request.post({
                        url: ApiURLs.compliance.attachmentDetails.replace(':id', id),
                        method: 'PUT',
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, payload)
                },
                delete: function (callback, errorCallback, id) {
                    Request.delete({
                        url: ApiURLs.compliance.attachmentDetails.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errorCallback
                    });
                },
                upload: function (callback, errorCallback, file) {
                    Request.upload({
                        url: ApiURLs.compliance.attachmentUpload,
                        method: 'POST',
                        successCallback: callback,
                        errorCallback: errorCallback,
                        fileKey: 'file'
                    }, file);
                }
            },
            reminders: {
                getAll: function (callback, errorCallback, filter) {
                    Request.get({
                        url: ApiURLs.compliance.reminder,
                        successCallback: callback,
                        errorCallback: errorCallback,
                        data: filter
                    });
                },
                create: function(callback, errorCallback, payload) {
                    Request.post({
                       url: ApiURLs.compliance.reminder,
                       method: 'POST',
                       successCallback: callback,
                       errorCallback: errorCallback
                    }, payload);
                },
                update: function(callback, errorCallback, id, payload) {
                    Request.post({
                        url: ApiURLs.compliance.reminderDetails.replace(':id', id),
                        method: 'PUT',
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, payload);
                },
                delete: function(callback, errorCallback, id) {
                    Request.delete({
                        url: ApiURLs.compliance.reminderDetails.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errorCallback
                    });
                }
            },
            triggers: {
                getAll: function (callback, errorCallback, filter) {
                    Request.get({
                        url: ApiURLs.compliance.trigger,
                        successCallback: callback,
                        errorCallback: errorCallback,
                        data: filter
                    });
                },
                create: function(callback, errorCallback, payload) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.compliance.trigger,
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, payload);
                },
                update: function(callback, errorCallback, id, payload) {
                    Request.post({
                        url: ApiURLs.compliance.triggerDetails.replace(':id', id),
                        method: 'PUT',
                        successCallback: callback,
                        errorCallback: errorCallback
                    }, payload);
                },
                delete: function(callback, errorCallback, id) {
                    Request.delete({
                        url: ApiURLs.compliance.triggerDetails.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errorCallback
                    });
                }
            }
        }
    });



// WEBPACK FOOTER //
// ./js/services/ComplianceService.js